<template>
<div id="div-trouble-container" class="div-lightbox-container">
    <div style="float:right;">
        <a href="javascript:void(0);" onclick="fToggleTroubleConnecting();"><img src="<% VAR(sLocationTemplateName) %>images/x.png" border="0" height="32" /></a>
    </div>
    <div style="padding:30px;">
        <table width="100%" align="left" border="0" cellpadding="0" cellspacing="0">
            <tr>
                <td align="right" colspan="2">

                </td>
            </tr>
            <tr>
                <td class="subhead" colspan="2">
                    Trouble Connecting?
                </td>
            </tr>
            <tr>
                <td class="form-spacer" colspan="2">
                </td>
            </tr>
            <tr>
                <td class="body-copy" colspan="2">
                    <p>
                        We apologize for the inconvenience.
                        <br /><br />
                        Please contact the front desk for assistance with your account.
                    </p>
                </td>
            </tr>
            <tr>
                <td class="form-spacer" colspan="2">
                </td>
            </tr>
            <tr>
                <td align="right" colspan="2">
                </td>
            </tr>
            <tr>
                <td class="form-spacer">
                </td>
            </tr>
            <tr>
                <td align="left">

                </td>
            </tr>
        </table>
    </div>
</div>
</template>

<script>

export default {
  name: "TroubleContainer"
}

</script>

<style scoped>

</style>